module.exports = __webpack_public_path__ + "img/town-hall.65a4dcef.webp";